import { createContext, useContext } from 'react'
import { useImmerReducer } from 'use-immer'

const CircuitDTCsContext = createContext(null)
const CircuitDTCsDispatch = createContext(null)

export function CircuitDTCsProvider({ children }) {
  const [state, dispatch] = useImmerReducer(reducer, initial)

  return (
    <CircuitDTCsContext.Provider value={state}>
      <CircuitDTCsDispatch.Provider value={dispatch}>
        {children}
      </CircuitDTCsDispatch.Provider>
    </CircuitDTCsContext.Provider>
  )
}

export function useCircuitDTCsContext() {
  return useContext(CircuitDTCsContext)
}

export function useCircuitDTCsDispatch() {
  const dispatch = useContext(CircuitDTCsDispatch)

  const reset = () => dispatch({ type: 'reset' })

  const handleCircuitProvided = ({ makeModelId, circuit }) => {
    dispatch({
      type: 'circuit_provided',
      makeModelId,
      circuit,
    })
  }

  const handleDTCProvided = ({ makeModelId, dtc, acronym }) => {
    dispatch({
      type: 'dtc_provided',
      makeModelId,
      dtc,
      acronym,
    })
  }

  return {
    handleCircuitProvided,
    handleDTCProvided,
    reset,
  }
}

function reducer(draft, action) {
  switch (action.type) {
    case 'reset': {
      draft.makeModelId = initial.makeModelId
      draft.circuit = initial.circuit
      draft.dtc.dtc = initial.dtc.dtc
      draft.dtc.acronym = initial.dtc.acronym
      break
    }
    case 'circuit_provided': {
      draft.makeModelId = action.makeModelId
      draft.circuit = action.circuit
      break
    }
    case 'dtc_provided': {
      draft.makeModelId = action.makeModelId
      draft.dtc.dtc = action.dtc
      draft.dtc.acronym = action.acronym
      break
    }

    default: {
      throw Error('Unknown action: ' + action.type)
    }
  }
}

const initial = {
  circuit: null,
  makeModelId: null,
  dtc: { dtc: null, acronym: null },
}
